// extracted by mini-css-extract-plugin
module.exports = {"inactive":"HipcooksBase_inactive_1jL9M"};